<Page name="tools" 
  infinite
  infiniteDistance={30}
  infinitePreloader={showPreloader}
  onInfinite={loadMore}>
  <Header page="tools" isSidebar={false} isCollapse={!isShowFilter} on:click={toggleSearchDisplay}/>
  {#if arroFilteredTool && oData}
  <div class="section-to-print-body"
  id="tools-page">
  <Row>
    <Col width="100">
      <BlockTitle style="float: left;">Tools {`(${arroFilteredTool.length})`}</BlockTitle>
    </Col>
  </Row>
  <div style="margin-left:15px;">
      <input bind:value={inputKeywords} 
                on:keyup={() => setTimeout(handleInput('keywords'), 400)} 
                on:change={()=> setTimeout(handleInput('keywords'), 400)}
                on:inputEmpty={() => console.log('empty')}
                class="inline"
                type="String" 
                placeholder="Keywords"
                style="background-color: white; padding: 8px 10px;
                box-shadow:0.5px 1px 1px 1px #cecece; width: 200px;
                color: rgb(81 145 206); text-transform: uppercase;">
      <!-- svelte-ignore a11y-no-onchange -->
      <select
          label="Categories"
          type="select"
          placeholder="Please choose..."
          class="inline wv-select"
          bind:value={iCategoryId}
          on:change={() => fFilterTools('category')}
      >
        <option value="" disabled selected>Select a category</option>
        <option value={null}
                  >All categories</option>
        {#each arroCategory as oCategory}
          <option value={oCategory[0]}
                  >{oCategory[1].name}</option>
        {/each}
      </select>
      <Button class="btn-print btn-print-tools inline"
              style="width:180px; display:inline-block;"
              onClick={() => printDiv('tools-page')}><i class="icon f7-icons">printer</i> Print This List</Button>
    </div>
  <Row>
    <Col>
      <List ul={false}>
        <ListGroup>
          {#each arroFilteredTool as oTool}
          <!-- <ListItem title="Group Title" groupTitle></ListItem> -->
            <ListItem>
              <Link href={oTool.url} external target="_blank">
              {@html oTool.title}
            </Link>
            </ListItem>
          {/each}
        </ListGroup>
      </List>
    </Col>
  </Row>
  </div>
  {/if}
  <Row><Footer/></Row>
</Page>
<script>
  import {
    Page,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    List,
    ListGroup,
    ListItem,
    Button,
    Preloader,
    Link,
    Block,
    Row,
    Col,
    SwipeoutActions,
    SwipeoutButton,
    BlockTitle,
    Input
  } from 'framework7-svelte';
  import { pluralize } from '../utils';
  import Header from '../components/Header.svelte';
  import Footer from '../components/Footer.svelte';
  import { getContext, onDestroy } from 'svelte';
  import { query, searchData } from '../stores.js';
  import About from './about.svelte';

  let page = 1;
  let items;
  let currentItem;
  let allowInfinite = true;
  let showPreloader = false;
  let sQuery = '';
  let grade;
  let isShowFilter = true;
  let inputKeywords="";

  let oData; 
  let oFilter;
  let arroCategory;

  let iCategoryId;
  let arroFilteredTool = [];

  $: showPreloader = (items) ? (items.length < 299) ? true : false : false;
  $: fFilterTools();

  const unsubscribeSearchData = searchData.subscribe(obj => {
    oData = obj;
    if (!oData) { return; }
    // Sort categories
    arroCategory = Object.entries(oData.categories);
    arroCategory.sort((a, b) =>a[1].name.localeCompare(b[1].name));
    fInitiateToolsData();
  });

  onDestroy(unsubscribeSearchData);
  /*
  categories

  generalRecommendation
  - specific []
  - categories []

  specificRecommendation:
  - generalRecommendation
  - tool []

  tools
  */

  function handleInput (key) {
    fFilterTools(key);
  }


  // Filter
  function filterByKeywords(tool) {
    var isincluded = false;
    var keywords = inputKeywords && inputKeywords.toLowerCase();
    // split keywords by space and quotes
    var arrsKeyword = keywords && keywords.match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);

    arrsKeyword && arrsKeyword.forEach(keyword => {
      const key = keyword.replace(/['"]+/g, '');
      if ((tool && tool.text.toLowerCase().includes(key)) ||
          (tool && tool.title.toLowerCase().includes(key)) ||
          (tool && tool.keywords.toLowerCase().includes(key))) {
            isincluded = true;
      }
    });
    return isincluded;
  }

  function fFilterTools(key) {
    if (!oData) { return; }
    // Reset topic array
    // arroTopic = ARROTOPICCONSTANT;

    if (!iCategoryId) { fInitiateToolsData(); }
    iCategoryId = parseInt(iCategoryId);
    let arriTool = [];
    const genRecArr = Object.keys(oData.generalRecommendations).filter(genRecId => {
      return oData.generalRecommendations[genRecId].categories.includes(iCategoryId.toString());
    });
    if (genRecArr.length > 0) {
      oData.specificRecommendations.map(oRec => {
        if(genRecArr.includes(oRec.general) && oRec.tool && oRec.tool.length > 0) {
          arriTool = [...arriTool, ...oRec.tool];
        };
      });
    }
    if (arriTool && arriTool.length > 0) {
      arroFilteredTool = [];
      const arriUniqueTool = [...new Set(arriTool)];
      arriUniqueTool && arriUniqueTool.forEach(iToolId=> {
        const obj = oData.tools[iToolId];
        if (obj) {
          obj.id = iToolId;
          arroFilteredTool.push(obj);
        }
      });
    }
    arroFilteredTool.sort((a, b) =>a.title.localeCompare(b.title));
     // Filter by keywords
     if (inputKeywords) {
      arroFilteredTool = arroFilteredTool.filter(filterByKeywords);
    }
  }

  function fInitiateToolsData() {
    if (!oData) { return; }
    Object.entries(oData);
    arroFilteredTool = Object.values(oData.tools);
    arroFilteredTool.sort((a, b) =>a.title.localeCompare(b.title));
  }

  function toggleSearchDisplay() {
    isShowFilter = !isShowFilter;
  }

  function loadMore() {
    if (!allowInfinite) return;
    allowInfinite = false;

    if (!showPreloader) return;
    
    page += 1;
  }

  function printDiv(divId) {
    document.getElementById(divId).classList.add("section-to-print-body");
    window.print();
    document.getElementById(divId).classList.remove("section-to-print-body");
  }
</script>
<style>
</style>